export default [
    {
        path: '/(uk/|ru/)?/payments/index',
        name: 'bill',
        query: true,
        component: () => import('../views/payments/bill'),
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-bill',
            title: 'История вывода средств'
        },
        children: [
            {
                path: '',
                name: 'bill-archive',
                component: () => import('../views/payments/modules/billArchive'),
                query: true,
                meta: {
                    requiresAuth: true,
                    title: 'Вывод средств'
                },
            },
        ]
    }, {
        path: '',
        name: 'TerminalReportMain',
        query: true,
        component: () => import('../views/terminals/Report'),
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-terminal',
            title: 'Отчетность терминалов'
        },
        children: [{
            path: '/(uk/|ru/)?/terminals/report',
            name: 'TerminalReport',
            query: true,
            component: () => import('../views/terminals/tabs/success'),
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-terminal',
                title: 'Отчетность терминалов'
            },
        }, {
            path: '/(uk/|ru/)?/terminals/report/error',
            name: 'TerminalReportError',
            query: true,
            component: () => import('../views/terminals/tabs/errors'),
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-terminal',
                title: 'Отчетность терминалов ошибки'
            },
        }, {
            path: '/(uk/|ru/)?/terminals/report/qr',
            name: 'TerminalReportQR',
            query: true,
            component: () => import('../views/terminals/tabs/qr'),
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-terminal',
                title: 'Отчетность терминалов ошибки'
            },
        }]
    }, {
        path: '/(uk/|ru/)?/terminals/config',
        name: 'TerminalSettings',
        query: true,
        component: () => import('../views/terminals/Config'),
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-terminal',
            title: 'Настройка терминалов'
        },
    }, {
        path: '/(uk/|ru/)?/terminals/create',
        name: 'TerminalCreate',
        query: true,
        component: () => import('../views/terminals/Create'),
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-terminal',
            title: 'Управление терминалами'
        },
    }, {
        path: '',
        name: 'PayCardsCreate',
        component: () => import('../views/cards/PayCards'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-card',
            title: 'Карты для Выплат',
            altNavSubMenuActive:'/cards/index',
        },
        children: [
            {
                path: '/(uk/|ru/)?/cards/index',
                name: 'PayCards',
                component: () => import('../views/cards/modules/Cards'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-card',
                    title: 'Карты'
                },
            }, {
                path: '/(uk/|ru/)?/cards/index/top',
                name: 'PayCardsTop',
                component: () => import('../views/cards/modules/TopCards'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-card',
                    title: 'Топ карт'
                },
            }, {
                path: '/(uk/|ru/)?/cards/exeption',
                name: 'PayCardsExeption',
                component: () => import('../views/cards/modules/Except'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-card',
                    title: 'Исключения мошеннических карт'
                },
            },
        ]
    }, {
        path: '/(uk/|ru/)?/cards/detail',
        name: 'Details',
        component: () => import('../views/cards/Details'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-card',
            title: 'Дитализация'
        },
    }, {
        path: '/(uk/|ru/)?/fraudulent/index',
        name: 'Fraudulent',
        component: () => import('../views/cards/Fraudulent'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-card',
            title: 'Мошеннические карты'
        },
    }, {
        path: '/(uk/|ru/)?/queue/index',
        name: 'QueuePayments',
        component: () => import('../views/payments/QueuePayments'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-bill',
            title: 'Очередь платежей'
        },
    }, {
        path: '/(uk/|ru/)?/hold-funds/index',
        component: () => import('../views/payments/HoldFunds'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-bill',
            title: 'Очередь платежей'
        },
        children: [
            {
                path: '',
                name: 'QueuePaymentsActive',
                component: () => import('../views/payments/modules/hfActive'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-bill',
                    title: 'Заморозка средств'
                },
            }, {
                path: '/(uk/|ru/)?/hold-funds/inactive',
                name: 'QueuePaymentsinActive',
                component: () => import('../views/payments/modules/hfInActive'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-bill',
                    title: 'Очередь платежей'
                },
            }
        ]
    }, {
        path: '/(uk/|ru/)?/provider/index',
        component: () => import('../views/payments/Provider'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-bill',
            title: 'Движение средств по счетам провайдеров'
        },
    }, {
        path: '/(uk/|ru/)?/payments/log-error-payments',
        component: () => import('../views/payments/Error'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-bill',
            title: 'Отчет ошибок платежей'
        },
    }, {
        path: '/(uk/|ru/)?/scheduled/list',
        component: () => import('../views/payments/Scheduled'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-bill',
            title: 'Запланированные платежи'
        },
    },
]
